export interface OperationsAppointment {
    startAt?: string | Date;
    status?: string;
    checkInTime?: string | Date;
    checkOutTime?: string | Date;
    wasLate?: boolean;
}

/**
 * Determines if an appointment is considered part of "Today's Volume".
 * Logic: Start Date is within local today (00:00 - 23:59).
 */
export function isAppointmentToday(appt: OperationsAppointment): boolean {
    if (!appt.startAt) return false;
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const endOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

    const apptDate = new Date(appt.startAt);
    return apptDate >= startOfToday && apptDate < endOfToday;
}

/**
 * Determines if an appointment is currently "Active" (occupying a dock).
 * Logic:
 * 1. Status is 'in_progress' — truck is physically at a dock.
 * 2. Note: 'checked_in' means the truck has arrived / is in the yard,
 *    but is NOT occupying a dock yet. Only in_progress = dock occupied.
 */
export function isActiveOccupant(appt: OperationsAppointment): boolean {
    const s = (appt.status || '').toLowerCase();
    return s === 'in_progress';
}

/**
 * Determines if an appointment is "Late" for Dashboard KPI purposes.
 * Logic: Must be CURRENTLY ACTIVE and marked as 'wasLate'.
 * We do not flag completed appointments as "Late" in the live operations view.
 */
export function isAppointmentLate(appt: OperationsAppointment): boolean {
    // Only count active appointments. If it's done, it's historical data, not operational alert.
    return isActiveOccupant(appt) && !!appt.wasLate;
}
